var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublishIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    transform: "matrix(1 0 0 -1 0 16)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76507 13.7578L11.9107 7.39517C12.0735 7.14518 12.0075 6.80732 11.763 6.64078C11.6758 6.58124 11.5732 6.5495 11.4684 6.54955H8.2088V2.54401C8.2088 2.24363 7.97087 2 7.67729 2C7.49949 2 7.3336 2.09087 7.23494 2.24221L3.08927 8.60483C2.9265 8.85482 2.99251 9.1925 3.23684 9.35922C3.32412 9.41881 3.4267 9.45062 3.53163 9.45063H6.7912V13.456C6.7912 13.7564 7.02914 14 7.32272 14C7.50052 14 7.66658 13.9091 7.76507 13.7578Z",
    fill: "#2454EF"
  })));
}

export default SvgPublishIcon;